export const ebuyQueryKeys = {
  all: (orgId: string) => ['ebuy-emails', orgId] as const,
  ingestEmail: (orgId: string) =>
    [...ebuyQueryKeys.all(orgId), 'ingest-email'] as const,
  // Opportunity-centric query keys
  opportunitiesBase: (orgId: string) =>
    [...ebuyQueryKeys.all(orgId), 'opportunities'] as const,
  opportunities: (orgId: string, params: object) =>
    [...ebuyQueryKeys.all(orgId), 'opportunities', { ...params }] as const,
  opportunitySearch: (orgId: string, params: object) =>
    [...ebuyQueryKeys.all(orgId), 'opportunity-search', { ...params }] as const,
  opportunity: (orgId: string, opportunityId: string) =>
    [...ebuyQueryKeys.all(orgId), 'opportunity', opportunityId] as const,
  opportunityUnreadCount: (orgId: string) =>
    [...ebuyQueryKeys.all(orgId), 'opportunity-unread-count'] as const,
  trackedSins: (orgId: string) =>
    [...ebuyQueryKeys.all(orgId), 'tracked-sins'] as const,
  attachment: (orgId: string, attachmentId: string) =>
    [...ebuyQueryKeys.all(orgId), 'attachment', attachmentId] as const,
}
